export default __webpack_public_path__ + "static/media/horizon.00d04ef2.jpeg";